import { Component, OnInit } from '@angular/core'
import { OverviewDTO } from '../../models/cabiancaChart.model'
import { DashboardService } from '../dashboard.service'
import { Router, ActivatedRoute } from '@angular/router'

@Component({
    selector: 'adminView-cmp',
    templateUrl: './adminView.component.html'
})
export class AdminViewComponent implements OnInit {
    admins: OverviewDTO[] = null
    month: number = 0
    year: number = 0
    totalRevenue: number = 0
    totalDonation: number = 0
    avgConversionImprove: number = 0
    avgTicketImproved: number = 0

    constructor(private dashboardService: DashboardService, public router: Router, private route: ActivatedRoute) {
    }

    ngOnInit() {
        this.route.queryParamMap.subscribe(params => {
            if (params["params"].mes) {
                this.month = params["params"].mes
            }
            if (params["params"].ano) {
                this.year = params["params"].ano
            }

            this.dashboardService.getAdminCabiancaChart(this.month, this.year).subscribe(data => {
                if (data != null) {
                    this.admins = data
                    debugger
                    var sumConversionImprove = 0

                    var sumConversionImprove = 0
                    var sumTicketWithDonation = 0
                    var sumTicketWithoutDonation = 0
                    var avgTicketWithoutDonation = 0
                    var avgTicketDonation = 0
                    this.admins.forEach(e => {
                        this.totalRevenue += e.revenueWithDonation
                        this.totalDonation += e.totalDonated
                        sumConversionImprove += e.conversionSalesImprovement
                        sumTicketWithDonation += e.avgTicketWithDonation
                        sumTicketWithoutDonation += e.avgTicketWithoutDonation
                    });

                    this.avgConversionImprove = sumConversionImprove / this.admins.length
                    avgTicketDonation = sumTicketWithDonation / this.admins.length
                    avgTicketWithoutDonation = sumTicketWithoutDonation / this.admins.length
                    this.avgTicketImproved = ((avgTicketDonation * 100) / avgTicketWithoutDonation) - 100


                }
            })
        })

    }

    filterPeriod() {
        var win = window.open('#/dashboard/adminview?mes=' + this.month + '&ano=' + this.year, '_blank');
        win.focus();
        // this.dashboardService.getAdminCabiancaChart(this.month, this.year).subscribe(data => {
        //     if (data != null) {
        //         this.admins = data
        //     }
        // })
    }
}
